import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TEXT_FIELD_STATUS, CONTEXT_PROVIDERS, SUCCESS } from '../../utils/constants';
import ConnectedTextField from '../_atomic/ConnectedTextField/ConnectedTextField';
import { getFieldInitialState, countryValidation } from '../../utils/helpers';
import Button from '../_atomic/Button/Button';
import InvoiceFormContext from './InvoiceFormContext';
import './InvoiceFrom.scss';

const bankNameFieldName = 'bank-name';
const countryFieldName = 'country';

class InvoiceForm extends Component {
  static propTypes = {
    submitHandler: PropTypes.func.isRequired,
    cardMethod: PropTypes.shape({}).isRequired,
    deleteCard: PropTypes.func.isRequired,
    deleteCardStatus: PropTypes.string.isRequired,
  }

  constructor() {
    super();
    this.fields = {};
  }
  state = {
    formStatus: TEXT_FIELD_STATUS.INITIAL,
    fields: {
      [bankNameFieldName]: getFieldInitialState(),
      [countryFieldName]: getFieldInitialState(),
    },
  }
  componentDidUpdate(prevProps) {
    const { deleteCardStatus, submitHandler } = this.props;
    if (deleteCardStatus !== prevProps.deleteCardStatus && deleteCardStatus === SUCCESS) {
      const fields = { ...this.state.fields };
      const data = {
        bankName: fields[bankNameFieldName].value,
        country: fields[countryFieldName].value,
      };
      submitHandler(data);
    }
  }
  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
       then form isn't valid or invalid it is initial */
    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID) {
        validFields += 1;
      }
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };

  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    let formStatus = {
      ...this.state.formStatus,
    };
    fields[name].value = value;

    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }

    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused }) => {
    const fields = {
      ...this.state.fields,
    };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };

  submitHandler = (e) => {
    e.preventDefault();
    const fields = {
      ...this.state.fields,
    };
    Object
      .keys(this.fields)
      .forEach((name) => {
        const { validator } = this.fields[name];
        const validate = validator(fields[name].value);
        fields[name].status = validate.status;
        fields[name].errorText = validate.errorText;
      });

    const formStatus = this.getFormStatus(fields);
    this.setState(() => ({ fields, formStatus }), () => {
      if (formStatus === TEXT_FIELD_STATUS.VALID) {
        const { submitHandler, deleteCard, cardMethod } = this.props;
        const data = {
          bankName: fields[bankNameFieldName].value,
          country: fields[countryFieldName].value,
        };
        if (!cardMethod.active) {
          submitHandler(data);
        } else {
          deleteCard();
        }
      }
    });
  };

  render() {
    const { fields, formStatus } = this.state;
    const bankNameField = fields[bankNameFieldName];
    const countryField = fields[countryFieldName];
    const isDisabled = formStatus === TEXT_FIELD_STATUS.INVALID;

    return (
      <div className="invoice-form-wrapper">
        <form action="" onSubmit={this.submitHandler}>
          <InvoiceFormContext.Provider
            value={{
            register: this.registerField,
            changeHandler: this.fieldChangeHandler,
            focusHandler: this.fieldFocusHandler,
          }}
          >
            <ConnectedTextField
              name={bankNameFieldName}
              value={bankNameField.value}
              status={bankNameField.status}
              isFocused={bankNameField.isFocused}
              errorText={bankNameField.errorText}
              hint={bankNameField.hint}
              contextProvider={CONTEXT_PROVIDERS.InvoiceFormContext}
              label="Bank Name"
              placeholder="Bank Name"
              isRequired
            />
            <ConnectedTextField
              name={countryFieldName}
              value={countryField.value}
              status={countryField.status}
              isFocused={countryField.isFocused}
              errorText={countryField.errorText}
              hint={countryField.hint}
              contextProvider={CONTEXT_PROVIDERS.InvoiceFormContext}
              specifiedValidator={countryValidation}
              label="Country"
              placeholder="Country"
              className="country-field"
              isRequired
            />
          </InvoiceFormContext.Provider>
          <div className="button-wrapper">
            <Button disabled={isDisabled} type="submit" label="Add" />
          </div>
        </form>
      </div>
    );
  }
}

export default InvoiceForm;



// WEBPACK FOOTER //
// ./src/components/InvoiceForm/InvoiceForm.js